import { handleRequest } from "../utilities/requestHandler";

export const getOrdersBySite = (req_body) =>
    handleRequest("post","/orders/getOrdersBySite",req_body);

export const getCombinedOrdersBySite = (req_body) =>
    handleRequest("post","/orders/getCombinedOrdersBySite",req_body);

// One row per quote, without line items - what the Quote History grid actually renders.
export const getOrdersListBySite = (req_body) =>
    handleRequest("post","/orders/getOrdersListBySite",req_body);

// A single quote's lines, loaded when a row is opened or expanded.
export const getOrderFullDetails = (req_body) =>
    handleRequest("post","/orders/getOrderFullDetails",req_body);

// Flat order+line rows for the XLSX export.
export const getOrdersExportBySite = (req_body) =>
    handleRequest("post","/orders/getOrdersExportBySite",req_body);

export const getOrderSchedules = (site_id) =>
    handleRequest("post","/orders/getOrderSchedules",{
        site_id: site_id,
    });

export const deleteOrderSchedule = (scheduleId) =>
    handleRequest("post","/orders/scheduleDelete",{
        id: scheduleId,
    });

export const getOrderTrackingDetails = (req_body) =>
    handleRequest("post","/orders/trackOrder",req_body);

export const updateQuoteNumber = (req_body) =>
    handleRequest("post","/orders/updateQuoteNumber",req_body);
